export default __webpack_public_path__ + "static/media/SWT0560.34I-18830_-25327_0.66ec10a3.jpg";